// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__UsuOw","description":"PatientConsentPreview_description__3d0IT"};